import confetti from 'canvas-confetti';
import cx from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import css from './Confetti.module.scss';

const defaultConfettiOptions = {
  origin: { y: 1.2 },
  particleCount: 200,
  spread: 75,
  ticks: 2500,
};

interface IConfettiProps {
  className?: string;
  confettiOptions?: any;
  onLoad?: () => void;
}

export const Confetti = ({
  className,
  confettiOptions,
  onLoad,
}: IConfettiProps) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const [canvas, setCanvas] = useState<HTMLCanvasElement>();

  const handleCanvasRef = useCallback((node: HTMLCanvasElement) => {
    if (node) {
      setCanvas(node);
    }
  }, []);

  useEffect(() => {
    if (canvas) {
      timeoutRef.current = setTimeout(() => {
        confetti.create(canvas, {
          disableForReducedMotion: true,
          resize: true,
          useWorker: true,
        })({
          ...defaultConfettiOptions,
          ...confettiOptions,
        });
        onLoad?.();
      }, 500);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [canvas]);

  return <canvas className={cx(css.canvas, className)} ref={handleCanvasRef} />;
};
